// =========================================================
// ANIMATIONS — orchestration init (GSAP + ScrollTrigger)
// - init après document.fonts.ready (évite le reflow texte mid-anim)
// - refresh ScrollTrigger au window.load (recalcule positions une fois
//   images / vidéos chargées)
// - API window.PDW pour re-init dynamique (preview ACF, AJAX)
// =========================================================
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initDataAnim } from "./anim_data_anim";

function initAllAnimations( scope = document ) {
    initDataAnim( scope );
}

// IMPORTANT : on révèle IMMÉDIATEMENT (sans attendre les fonts). La garde anti-flash
// `has-anim` masque tout le contenu tant qu'elle est posée — si on attendait
// document.fonts.ready pour la retirer, la page resterait blanche/figée tout le temps
// du chargement des polices (= le « gel » au refresh). On init donc dès le DOM prêt,
// puis on recalcule les positions ScrollTrigger quand fonts + images sont chargées.
function reveal() {
    // On diffère d'une frame : ça laisse les animations CSS d'entrée (hero, [data-anim-css])
    // démarrer en priorité sans être saccadées par le travail main-thread de gsap.
    // Ordre conservé : gsap.set (masque inline) PUIS retrait de has-anim → pas de flash
    // du contenu sous la ligne de flottaison.
    requestAnimationFrame( () => {
        initAllAnimations();
        document.documentElement.classList.remove( "has-anim" );
    } );
}

if ( document.readyState !== "loading" ) {
    reveal();
} else {
    document.addEventListener( "DOMContentLoaded", reveal );
}

// Recalage des positions une fois les polices chargées (le texte peut se reflow)
document.fonts.ready.then( () => ScrollTrigger.refresh() );

window.addEventListener( "load", () => {
    requestAnimationFrame( () => ScrollTrigger.refresh() );
} );

// API globale pour contenus chargés dynamiquement
window.PDW = window.PDW || {};
window.PDW.initAllAnimations    = initAllAnimations;
window.PDW.refreshAllAnimations = () => ScrollTrigger.refresh();
